import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Cache busting - force fresh config
if (typeof window !== 'undefined') {
  // Clear any cached Amplify configuration
  try {
    localStorage.removeItem('amplify-config-cache');
    sessionStorage.removeItem('amplify-config-cache');
  } catch (error) {
    console.warn('Could not clear config cache:', error);
  }
}

// Debug configuration (development only)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Environment:', {
    NODE_ENV: process.env.NODE_ENV,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'server',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'server'
  });

  console.log('🔧 Raw AWS Exports:', {
    userPoolId: awsExports.aws_user_pools_id,
    userPoolClientId: awsExports.aws_user_pools_web_client_id,
    region: awsExports.aws_cognito_region,
    oauthDomain: awsExports.oauth?.domain,
    hasOAuth: !!awsExports.oauth
  });
}

// Override the OAuth domain explicitly
const overriddenAwsExports = {
  ...awsExports,
  oauth: {
    ...awsExports.oauth,
    domain: 'signin.hypecircle.co.in' // Forced custom domain
  }
};

// Configure Amplify with the current aws-exports
try {
  Amplify.configure(overriddenAwsExports);
  if (process.env.NODE_ENV === 'development') {
    //console.log('✅ Amplify.configure() completed successfully');
    // console.log('🔧 Using configuration:', {
    //   userPoolId: awsExports.aws_user_pools_id,
    //   userPoolClientId: awsExports.aws_user_pools_web_client_id,
    //   region: awsExports.aws_cognito_region,
    //   oauthDomain: awsExports.oauth?.domain
    // });
  }
} catch (error) {
  console.error('❌ Amplify.configure() failed:', error);
  throw error;
}

// Verify configuration after setup
if (process.env.NODE_ENV === 'development') {
  try {
    const config = Amplify.getConfig();
    console.log('✅ Amplify Configuration Verified:', {
      userPoolId: config.Auth?.Cognito?.userPoolId,
      userPoolClientId: config.Auth?.Cognito?.userPoolClientId,
      region: config.Auth?.Cognito?.region,
      hasAuth: !!config.Auth,
      hasCognito: !!config.Auth?.Cognito,
      hasOAuth: !!config.Auth?.Cognito?.loginWith?.oauth
    });
  } catch (error) {
    console.error('❌ Failed to get Amplify config:', error);
  }
}

// Final validation (development only)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  setTimeout(() => {
    try {
      const finalConfig = Amplify.getConfig();
      if (!finalConfig.Auth?.Cognito?.userPoolId) {
        console.error('🚨 CRITICAL: UserPool not found in final config!');
        console.error('Final config:', finalConfig);
      } else {
        console.log('🎉 Auth configuration validated successfully');
      }
    } catch (error) {
      console.error('🚨 Final validation failed:', error);
    }
  }, 100);
}

export default Amplify;